module.exports = __webpack_public_path__ + "media/images/icon-stats-2e629f10aa5d7066ef34c0a0c6164338.png";